export function htmlToPlainText(html: string): string {
  if (typeof document === "undefined") {
    return html.replace(/<br\s*\/?>/gi, "\n").replace(/<\/p\s*>/gi, "\n\n")
      .replace(/<[^>]*>/g, "").replace(/\n{3,}/g, "\n\n").trim();
  }
  const root = document.createElement("div");
  root.innerHTML = html;
  root.querySelectorAll("script,style,iframe,object").forEach((node) => node.remove());
  root.querySelectorAll("br").forEach((node) => node.replaceWith("\n"));
  root.querySelectorAll("p,div,li,section,article").forEach((node) => {
    node.insertAdjacentText("afterend", "\n\n");
  });
  return (root.textContent || "").replace(/\u00a0/g, " ").replace(/[ \t]+\n/g, "\n").replace(/\n{3,}/g, "\n\n").trim();
}

export function plainTextToHtml(text: string): string {
  const escape = (value: string) => value.replace(/&/g, "&amp;").replace(/</g, "&lt;")
    .replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  return text.trim().split(/\n{2,}/).map((block) =>
    `<p>${block.split("\n").map(escape).join("<br>")}</p>`
  ).join("");
}

export function containsTemplatePlaceholder(value: string): boolean {
  return value.includes("{{");
}

export function resolveEmailModelLabel(
  code: string | null | undefined,
  models: Array<{ code: string; libelle: string }> | undefined,
): string | null {
  if (!code) return null;
  return models?.find((model) => model.code === code)?.libelle ?? code;
}

/** Allow the formatting tags generated by email templates, stripping active content. */
export function sanitizeEmailHtml(html: string): string {
  if (typeof document === "undefined") return "";
  const template = document.createElement("template");
  template.innerHTML = html;
  const allowed = new Set(["P", "BR", "STRONG", "B", "EM", "I", "U", "UL", "OL", "LI", "A", "H1", "H2", "H3", "DIV", "SPAN"]);
  template.content.querySelectorAll("*").forEach((element) => {
    if (!allowed.has(element.tagName)) {
      element.replaceWith(...Array.from(element.childNodes));
      return;
    }
    Array.from(element.attributes).forEach((attribute) => {
      if (attribute.name !== "href" || element.tagName !== "A" || !/^https?:\/\//i.test(attribute.value)) {
        element.removeAttribute(attribute.name);
      }
    });
  });
  return template.innerHTML;
}